import { Button, Col, Form, Input, Progress, Radio, Result, Row } from 'antd'
import client from 'apollo'
import {
  RightCircleFilled,
  CheckCircleFilled,
  InfoCircleOutlined,
} from '@ant-design/icons'
import CustomMeta from 'components/CustomMeta'
import React, { useContext, useState } from 'react'
import UPI_image from '../../assets/images/upi-image.png'
import {
  COMPLETE_STEP,
  ENCRYPT_UPI_ID,
  PAYMENT,
  VERIFY_UPI,
} from './graphql/Mutations'
import { AppContext } from 'AppContext'
import { UPDATE_USER } from 'modules/Users/graphql/Mutations'
import { GET_ALL_AMC } from 'modules/Users/graphql/Queries'
import { GET_TRANSACTION } from 'modules/Transactions/Graphql/Queries'
import QRCode from 'react-qr-code'
import { GET_ALL_NOTIFICATION_FOR_CLIENT } from 'auth/graphql/Queries'

const FormItem = Form.Item

export default function UpiPayment({
  exposure,
  amount,
  amcId,
  lotSize,
  limit,
  skip,
  filters,
  transactionStatus,
  setTransactionStatus,
  showQrCode,
  qrCodeUrl,
  upiInputModel,
  setUpiInputModel,
  transactionId,
  gstAmount,
  grossTotalAmount,
  isOnBoard,
}) {
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)
  // const withoutGstAmount = +Math.round(amount / 1.18)
  const withoutGstAmount = +Math.round(amount)

  const checkPaymentSuccess = (upiTransactionId, status) => {
    let count = 0
    if (status === 'PENDING' || status === null) {
      const callApiAtEvery = setInterval(() => {
        if (upiTransactionId) {
          client
            .query({
              query: GET_TRANSACTION,
              variables: {
                where: { transactionId: upiTransactionId },
              },
              fetchPolicy: 'network-only',
            })
            .then((res) => {
              count++
              console.log(count)
              if (res?.data?.getTransaction?.status === 'SUCCESS') {
                client
                  .query({
                    query: GET_ALL_NOTIFICATION_FOR_CLIENT,
                    fetchPolicy: 'network-only',
                  })
                  .then((response) => {
                    dispatch({
                      type: 'ALL_NOTIFICATIONS_FOR_CLIENT',
                      data: response?.data?.getNotifications,
                    })
                  })
                  .catch((err) => console.log(err))
                setTransactionStatus('SUCCESS')
                if (completedSteps !== 'DONE') {
                  let data = {}
                  if (isNewAuaAdvisoryGenerate) {
                    data.newAuaAdvisoryCompletedSteps = 'ADVISORY_FEES'
                  } else {
                    data.completedSteps = 'E_MANDATE'
                  }
                  client
                    .mutate({
                      mutation: UPDATE_USER,
                      variables: { id, data: { ...data } },
                    })
                    .then((res) => {
                      if (isOnBoard) {
                        client.mutate({
                          mutation: COMPLETE_STEP,
                          variables: {
                            data: { step: 'E_MANDATE', from: 'WEB' },
                          },
                        })
                      }
                    })
                }
                clearInterval(callApiAtEvery)
              }

              if (
                res?.data?.getTransaction?.status === 'FAILED' ||
                res?.data?.getTransaction?.status === 'FAILURE' ||
                res?.data?.getTransaction?.status === 'SPAM' ||
                res?.data?.getTransaction?.status === 'REJECTED' ||
                res?.data?.getTransaction?.status === 'EXPIRED'
              ) {
                setTransactionStatus('ERROR')
                clearInterval(callApiAtEvery)
              }

              if (count >= 120) {
                setTransactionStatus('ERROR')
                clearInterval(callApiAtEvery)
              }
              return
            })
        }
      }, 5000)
    }
  }

  // const [pendingModel, setPendingModel] = useState(false)

  // const [transactionSuccess, setTransactionSuccess] = useState(true)
  const [timer, setTimer] = useState('')
  const [timerPer, setTimerPer] = useState(0)

  const {
    state: {
      currentUser: { id, completedSteps, isNewAuaAdvisoryGenerate },
    },
    dispatch,
  } = useContext(AppContext)

  const [payment, setPayment] = useState({})
  const [data, setData] = useState('')

  // const handleCancel = () => {
  //   setTransactionStatus('')
  // }

  const twoDigits = (n) => {
    return n <= 9 ? '0' + n : n
  }
  const setTimeCountDown = (minutes, seconds) => {
    let endTime, hours, mins, msLeft, time

    const updateTimer = () => {
      msLeft = endTime - +new Date()
      if (msLeft < 1000) {
        // setTransactionSuccess(false)
        setTimer('Time is up!')
        setPayment({})
        setLoading(false)
      } else {
        time = new Date(msLeft)
        hours = time.getUTCHours()
        mins = time.getUTCMinutes()
        setTimer(
          (hours ? hours + ':' + twoDigits(mins) : mins) +
            ':' +
            twoDigits(time.getUTCSeconds())
        )
        if (timerPer <= 100) {
          setTimerPer((old) => old + 0.1667)
        }
        setTimeout(updateTimer, time.getUTCMilliseconds() + 500)
      }
    }

    endTime = +new Date() + 1000 * (60 * minutes + seconds) + 500
    updateTimer()
  }

  const onFinish = async () => {
    setUpiInputModel(false)
    setLoading(true)
    // setPendingModel(true)
    setTransactionStatus('IN_PROCESS')
    setTimeCountDown(10, 0)
    let upi = ''
    client
      .mutate({
        mutation: ENCRYPT_UPI_ID,
        variables: { data: { upiId: data } },
      })
      .then((res) => {
        upi = res?.data?.encryptUpi
        client
          .mutate({
            mutation: VERIFY_UPI,
            variables: {
              data: {
                upiId: res?.data?.encryptUpi,
                transactionId,
              },
            },
          })
          .then((res) => {
            setLoading(true)
            let obj = {
              transactionId: transactionId,
              amount: amount,
              upiId: upi,
              amcId,
              userId: parseInt(id),
              lotSize,
              amountWithGST: Math.round(amount + amount * 0.18),
            }
            client
              .mutate({
                mutation: PAYMENT,
                variables: { data: { ...obj } },
                refetchQueries: [
                  {
                    query: GET_ALL_AMC,
                    variables: { where: { ...filters }, limit, skip },
                    fetchPolicy: 'network-only',
                  },
                ],
              })
              .then(async (res) => {
                let obj = {
                  ...res?.data?.PaymentAmc,
                  message: `Transaction Id: ${res?.data?.PaymentAmc?.transactionId}`,
                }

                await checkPaymentSuccess(
                  res?.data?.PaymentAmc?.transactionId,
                  res?.data?.PaymentAmc?.status
                )
                setPayment(obj)
                // openNotification('success', 'Transaction Successful')
                setLoading(false)
                setTimer('')
                setTimerPer(0)
              })
              .catch((err) => {
                console.log({ err })
                setLoading(false)
                setTimer('')
                setTimerPer(0)
                setTransactionStatus('ERROR')
              })
              .finally(() => {
                setLoading(false)
                setTimer('')
                setTimerPer(0)
              })
          })
          .catch((err) => {
            console.log({ err })
            setLoading(false)
            setTimer('')
            setTimerPer(0)
            setTransactionStatus('ERROR')
          })
      })
      .catch((err) => {
        console.log({ err })
        setTransactionStatus('ERROR')
      })
  }

  // const handleShowQr = () => {
  //   client
  //     .mutate({
  //       mutation: CREATE_TRANSACTION_VIA_UPI,
  //       variables: { data: { amount, amcId, lotSize } },
  //     })
  //     .then((res) => {
  //       setQrCodeUrl(res?.data?.createTransactionViaUpi?.url)
  //       setShowQrCode(true)

  //       let upiTransactionId = res?.data?.createTransactionViaUpi?.transactionId
  //       let status = res?.data?.createTransactionViaUpi?.status
  //       let upiTxnNumber = res?.data?.createTransactionViaUpi?.upiTxnNo

  //       checkQrPaymentSuccess(upiTransactionId, status, upiTxnNumber)
  //     })
  //     .catch((err) => console.log({ err }))
  // }

  const handleCloseFailPayment = () => {
    window.location.reload()
  }

  return (
    <>
      <div
        className='upi-payment-wrapper'
        style={{ overflowX: 'hidden', overflowY: 'hidden' }}
      >
        <CustomMeta title='UPI Payment' />
        {upiInputModel ? (
          <>
            <Row gutter={16} style={{ marginTop: '20px' }}>
              <Col md={12}>
                <div
                  style={{
                    // marginLeft: "20px",
                    background: '#fff',
                    height: '100%',
                    display: 'grid',
                    // alignItems: "center",
                  }}
                >
                  <Row style={{ display: 'block', padding: '15px' }}>
                    <div>
                      <Radio.Group value={1}>
                        <Radio value={1}>
                          <img
                            style={{ width: '50px' }}
                            src={UPI_image}
                            // src='https://media.tenor.com/kGFp0e2m_RsAAAAM/success.gif'
                            alt=''
                          />
                        </Radio>
                      </Radio.Group>
                    </div>

                    <div style={{ marginTop: '10px' }}>
                      <Form
                        form={form}
                        name='register'
                        labelAlign='left'
                        scrollToFirstError
                        onFinish={onFinish}
                      >
                        <FormItem
                          name='upiId'
                          label='UPI ID:'
                          rules={[
                            {
                              required: true,
                              pattern: new RegExp(/[.\-a-z0-9]+@[a-zA-Z]+/),
                              message: 'UPI ID is Required',
                            },
                          ]}
                        >
                          <Input
                            onChange={(e) =>
                              setData(e?.target?.value?.toLocaleLowerCase())
                            }
                            className='input-placeholder'
                            placeholder='Enter VPA'
                            autoFocus={true}
                            style={{ width: '90%', textAlign: 'center' }}
                            autoComplete='off'
                          />
                        </FormItem>
                        <FormItem>
                          <div>
                            <Button
                              type='primary'
                              loading={loading}
                              style={{ width: '100%' }}
                              htmlType='submit'
                              disabled={!qrCodeUrl ? true : false}
                            >
                              Verify And Pay
                            </Button>
                          </div>
                        </FormItem>
                      </Form>
                    </div>
                    <div>
                      <img
                        style={{ width: '80px' }}
                        src='data:image/png;base64,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'
                        alt=''
                      />
                      <img
                        style={{ width: '80px' }}
                        src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRC-iA1KoqvQI6NvTcu6b5YpRIyhOzJcMfBYQ&usqp=CAU'
                        alt=''
                      />
                      <img
                        style={{ width: '80px' }}
                        src='data:image/png;base64,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'
                        alt=''
                      />
                      <img
                        style={{ width: '80px' }}
                        src='data:image/png;base64,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'
                        alt=''
                      />
                    </div>

                    <div className='payment_warning'>
                      <span>
                        Note:- Payments to Finideas AMC must be made in the name
                        of the Registered KYC person only. Third-party payments
                        are not permitted.
                      </span>
                    </div>
                  </Row>
                </div>
              </Col>
              <Col md={12}>
                <div
                  style={{
                    marginLeft: '20px',
                    background: '#fff',
                    height: '100%',
                  }}
                >
                  <Row style={{ display: 'block', padding: '15px' }}>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        marginBottom: '1.5rem',
                      }}
                    >
                      {!qrCodeUrl ? (
                        <Result
                          icon={
                            <img
                              src='https://assets.materialup.com/uploads/44a16bfa-b402-484e-aba1-71dcceb0b828/preview.gif'
                              alt=''
                              style={{ width: '150px', height: '150px' }}
                            />
                          }
                        />
                      ) : (
                        <QRCode
                          size={200}
                          style={{
                            width: '200px',
                            height: '200px',
                          }}
                          value={qrCodeUrl}
                          viewBox={`0 0 200 200`}
                        />
                      )}
                    </div>
                    <h3 style={{ textAlign: 'left' }}>Summary</h3>
                    <Row>
                      <Col md={12} className='payment_col'>
                        <div
                          style={{
                            display: 'grid',
                            textAlign: 'left',
                            marginRight: '16px',
                          }}
                        >
                          <span>AUA</span>
                          <span>AMC Gross Amount</span>
                          <span>Gst 18%</span>
                        </div>
                      </Col>
                      <Col md={12} className='payment_col'>
                        <Col md={8} className='payment_col'>
                          <div style={{ display: 'grid', textAlign: 'right' }}>
                            <span>{`Rs.${exposure}`}</span>
                            <span>{`Rs.${withoutGstAmount}`}</span>
                            <span>{`RS.${gstAmount}`}</span>
                          </div>
                        </Col>
                      </Col>
                    </Row>
                    <hr />
                    <Row>
                      <Col md={12} className='payment_col'>
                        <div style={{ display: 'grid', textAlign: 'left' }}>
                          <span>AMC Amount To Pay</span>
                        </div>
                      </Col>
                      <Col md={12} className='payment_col'>
                        <Col md={10}>
                          <span style={{ display: 'grid', textAlign: 'right' }}>
                            <b>{`RS.${grossTotalAmount}`}</b>
                          </span>
                        </Col>
                      </Col>
                    </Row>
                  </Row>
                </div>
              </Col>
            </Row>
          </>
        ) : transactionStatus === 'SUCCESS' ? (
          <Result
            icon={
              <img
                src='https://media.tenor.com/0AVbKGY_MxMAAAAM/check-mark-verified.gif'
                alt=''
                style={{ width: '100px' }}
              />
            }
            title='Payment Successful!'
            subTitle={payment?.message} //display transaction id from backend
          />
        ) : transactionStatus === 'ERROR' ? (
          <>
            <Result
              icon={
                <img
                  src='https://i0.wp.com/balututorials.com/wp-content/uploads/2020/07/Error.gif'
                  alt=''
                  style={{ width: '100px' }}
                />
              }
              title={`${
                transactionStatus === 'ERROR'
                  ? 'Transaction Declined'
                  : 'Transaction Timeout'
              }`}
              subTitle='Please try again in sometime'
              extra={[
                <Button type='primary' onClick={handleCloseFailPayment}>
                  Retry
                </Button>,
              ]}
            />
          </>
        ) : (
          <div style={{ width: '100%' }}>
            <b style={{ fontSize: '25px' }}>Make Payment</b>
            <div style={{ marginTop: '30px', fontSize: '15px' }}>
              <div style={{ display: 'flex' }}>
                <div>
                  <RightCircleFilled style={{ fontSize: '20px' }} />
                </div>
                <p style={{ marginLeft: '11px' }}>
                  Open the Mobile app linked with your UPI ID
                </p>
              </div>
              <div style={{ display: 'flex' }}>
                <div>
                  <RightCircleFilled style={{ fontSize: '20px' }} />
                </div>
                <p style={{ marginLeft: '11px' }}>
                  Check Payment Requests or Notifications.
                </p>
              </div>
              <div style={{ display: 'flex' }}>
                <div>
                  <CheckCircleFilled style={{ fontSize: '20px' }} />
                </div>
                <p style={{ marginLeft: '11px' }}>
                  Approve Payment and Complete the transaction by entering your
                  PIN
                </p>
              </div>
            </div>
            <div style={{ display: 'flex', marginTop: '30px' }}>
              <div style={{ fontSize: '18px' }}>
                <InfoCircleOutlined />
              </div>
              <div style={{ fontSize: '13px' }}>
                <p style={{ marginLeft: '11px' }}>
                  <b>Note:</b> Incase the UPI ID is of another person, kindly
                  authorise the payment from their device.
                </p>
              </div>
            </div>
            <hr />
            <div>
              <div>
                {transactionStatus === 'IN_PROCESS' ? (
                  <p>{`This page will automatically expire in ${timer} mins.`}</p>
                ) : (
                  <p>{`Transaction Session Time Out`}</p>
                )}
              </div>
              <Progress percent={timerPer} showInfo={false} />
            </div>
            <div style={{ display: 'flex', marginTop: '20px' }}>
              <div style={{ fontSize: '16px', color: '#af0000' }}>
                <p style={{ marginLeft: '11px' }}>
                  <b>Warning:</b> Do not refresh the page or Don't close Screen
                </p>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* {transactionStatus === 'IN_PROCESS' && (
        <Modal
          visible={transactionStatus === 'IN_PROCESS'}
          onCancel={handleCancel}
          footer={null}
        ></Modal>
      )} */}
    </>
  )
}
